export default __webpack_public_path__ + "static/media/Grenzgaenger_Logo.983614a6.jpg";